import {
  LineChart,
  TrendingUp,
  Globe2,
  Workflow,
  SearchCheck,
  GraduationCap,
} from "lucide-react";
import { useLang } from "@/i18n";

const ICONS = [LineChart, TrendingUp, Globe2, Workflow, SearchCheck, GraduationCap];

export default function Services() {
  const { t } = useLang();
  return (
    <section id="services" className="relative py-24 sm:py-32">
      <div className="pointer-events-none absolute inset-0 bg-gradient-to-b from-[#FAF8F4] via-[#F0ECE4]/70 to-[#FAF8F4]" />
      <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
        <div className="max-w-2xl">
          <p className="eyebrow" data-testid="services-eyebrow">{t.services.eyebrow}</p>
          <h2 className="mt-5 font-display text-3xl font-semibold tracking-tight text-[#3B322A] sm:text-4xl" data-testid="services-title">
            {t.services.title1}
            <span className="gold-gradient-text italic">{t.services.titleAccent}</span>
          </h2>
          <p className="mt-5 text-base leading-relaxed text-[#5F5647]">
            {t.services.sub}
          </p>
        </div>

        <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {t.services.items.map((s, i) => {
            const Icon = ICONS[i];
            return (
              <article
                key={s.testid}
                data-testid={s.testid}
                className="card-lux group flex flex-col rounded-md p-7"
              >
                <div className="flex items-center justify-between">
                  <div className={`flex h-12 w-12 items-center justify-center rounded-sm border transition-colors duration-300 ${i % 2 ? "border-[#C09A6B]/40 bg-[#C09A6B]/10 text-[#856237] group-hover:bg-[#C09A6B]/20" : "border-[#A87C4F]/40 bg-[#A87C4F]/10 text-[#856237] group-hover:bg-[#A87C4F]/20"}`}>
                    <Icon size={22} strokeWidth={1.6} />
                  </div>
                  <span className="font-mono-eyebrow text-[10px] uppercase tracking-[0.2em] text-[#948678]">
                    {s.tag}
                  </span>
                </div>
                <h3 className="mt-6 font-display text-xl font-semibold leading-snug text-[#3B322A]">
                  {s.title}
                </h3>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-[#948678]">{s.description}</p>
                <div className="gold-hairline mt-6 opacity-60" />
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
